export const createIframe = (blobUrl: string) => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);
  iframe.onload = function () {
    iframe.contentWindow!.print();
  };
};
